module.exports = __webpack_public_path__ + "static/media/H.92edab0f.jpg";